<section id="delivery-details">
  <h2>ID VTs de l'article {{ article.code_article }} ({{ article.designation }}) livré le {{ date | momentFormat: 'DD/MM/YYYY' }}</h2>
  <article>
    <table mat-table [dataSource]="dataSource">
      <ng-container *ngFor="let column of columns">
        <ng-container matColumnDef="{{column.id}}">
          <th mat-header-cell *matHeaderCellDef>{{ column.libelle }}</th>
          <td mat-cell *matCellDef="let element">{{ element[column.id] }}</td>
        </ng-container>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </article>
</section>
